import React from 'react';

import type { PolymorphicRef } from '../types/polymorphicAsProp';
import type { StackProps } from './Stack';
import { Stack } from './Stack';

export type HStackProps = StackProps<'div'> & {
  children: React.ReactNode;
  reverse?: boolean;
};

export const HStack = React.forwardRef(
  <Tag extends React.ElementType>(
    { children, reverse, ...remaining }: HStackProps,
    ref: PolymorphicRef<Tag>,
  ) => (
    <Stack {...remaining} direction={reverse ? 'row-reverse' : 'row'} ref={ref}>
      {children}
    </Stack>
  ),
);
